// export const WEB_PAYMENT_TERMINAL_IDS = [8174, 6344, 6187, 7677];

// export const isWebPaymentTerminal = (terminalId: number) => {
// 	return WEB_PAYMENT_TERMINAL_IDS.includes(terminalId);
// };

const NOT_ALLOWED_HOSTNAMES = [''];

// В будущем возможно понадобится для отключения 1click для определнных доменов
export const isWebPaymentAvailable = () =>
	!NOT_ALLOWED_HOSTNAMES.includes(window.location.hostname);

/**
 * Аварийный выключатель нативного Apple Pay в вебвью супераппа.
 *
 * Внутри вебвью Apple Pay JS не работает (WebKit отключает ApplePaySession при инжекте
 * user scripts), поэтому «выключить» здесь означает скрыть метод целиком, а не откатиться
 * на веб-реализацию. Это осознанный аварийный режим: лучше без Apple Pay, чем со сломанным.
 *
 * В обычном браузере флаг ни на что не влияет — там всегда Apple Pay JS.
 */
export const isApplePayNativeDisabled = () =>
	import.meta.env.VITE_DISABLE_APPLE_PAY_NATIVE === 'true';
